module.exports = __webpack_public_path__ + "static/media/slider_bg_mob_2.e3884161.jpg";